import React from 'react';
import { render } from 'react-dom';
import Login from './containers/login';

render(
	<Login />,
	document.getElementById('root')
);
